/**
 * 
 * @param {Array} thumbnails  - array or nodelist of thumnail elements
 * @param {String} thumbailDataAttr - data attr on thumbnail that contains the positions
 * @param {String} activeClass - active class name to be added to the active thumbnail
 * @returns {Function(position{Number})} - function that takes the position of a thumbnail and returns an (impure) function that updates the active thumbnail to the one with that index
 */


const setActiveThumbnail = (thumbnails, thumbailDataAttr, activeClass) => position => {
  [...thumbnails].forEach(
    thumbnail => {
      if (parseInt(thumbnail.getAttribute(thumbailDataAttr)) === position) {
        thumbnail.parentElement.classList.add(activeClass);
      } else {
        thumbnail.parentElement.classList.remove(activeClass);
      }
    }
  )
}

export default setActiveThumbnail;